import LayoutSidebarAdmin from '@/components/layouts/layout-admin/index.vue'

import { RouteRecordRaw } from 'vue-router'
import { translate } from '@/languages/i18n'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: '/community/communities/:id/edit',
      name: 'community-edit',
      component: () => import('@/views/community-admin/edit-community/index.vue'),
      meta: {
        title: translate('titleHeadCommunityAdmin'),
        layout: LayoutSidebarAdmin,
        screenId: 'CO40',
      },
    },
  ]
}
